import type { ToastDismissReason, ToastRecord } from './toast-context';
import { ToastItem } from './ToastItem';
import s from './ToastViewport.module.css';

interface ToastViewportProps {
  toasts: readonly ToastRecord[];
  onDismiss: (id: string, reason: ToastDismissReason) => void;
}

/**
 * Where toasts land: bottom-right on a desktop, bottom-centre above the tab
 * bar on a phone. Fixed and outside every scroll container, so it never
 * depends on which screen is mounted — including none.
 */
export function ToastViewport({ toasts, onDismiss }: ToastViewportProps): JSX.Element | null {
  if (toasts.length === 0) return null;
  return (
    <section className={s.root} aria-label="Notifications">
      {toasts.map((toast) => (
        <ToastItem key={toast.id} toast={toast} onDismiss={onDismiss} />
      ))}
    </section>
  );
}
